import { render, staticRenderFns } from "./selectPBBrand.vue?vue&type=template&id=25b7cd5c"
import script from "./selectPBBrand.vue?vue&type=script&lang=js"
export * from "./selectPBBrand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports